
export default {
  props: {
    error: {
      type: String,
      required: false,
      default: "There was an error. Please try again.",
    },
  },
};
